import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
// Side-effect import: configures the shared API client before anything renders.
import "./api/configureApiClient";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);
